<template>
    <main>

    </main>
</template>

<script>
    export default {
        name: 'exit',
        data() {
            return {
                query:"",
            }
        },
        components:{

        },
        computed:{
            crumbs() {
                return [

                ]
            },
        },
        methods: {
            exit(){
                this.util.setAccessToken('');
                this.$store.commit('setUserInfo',{});

                var name = "smarketMember_498";
                var value = "";
                var oDate = new Date();
                oDate.setDate(oDate.getDate() - 1);
                var domain = ".dellemc-solution.com";
                document.cookie = name + '=' + value + ';expires=' + oDate + ';domain='+domain+';path=/';

                this.util.toBack();
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.exit();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .message{height:200px;line-height: 200px;width: 1200px;margin: 0 auto;}
</style>

